/*
 * Public API Surface of fab-menu
 */

export * from './lib/mat-fab-menu.component';
export * from './lib/mat-fab-menu.module';
